/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:store
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/02 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/08/07 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.02.00 | 2023/11/22 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.03.00 | 2024/09/17 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
 */
// STORE定数
// エラー設定
export const STORE_ERROR_SETMSG = 'error/setError';
export const STORE_ERROR_CLEAR = 'error/clear';
export const STORE_ERROR_IS_ERRFLG = 'error/isErrFlg';
export const STORE_ERROR_GET_ERRMSG = 'error/getErrMsg';
export const STORE_ERROR_SET_INPUT_ERR = 'error/setInputError';
export const STORE_ERROR_GET_INPUT_ERRMSG = 'error/getInputErrMsg';
export const STORE_ERROR_IS_INPUT_ERRFLG = 'error/isInputErrFlg';
export const STORE_ERROR_DELETE_ID = 'error/deleteGroupId';
// export const STORE_ERROR_DELETE_AT = 'error/deleteAt';

// 画面設定
export const STORE_VIEW_NAME = 'view/setName';
export const STORE_VIEW_TITLE = 'view/setTitle';
export const STORE_VIEW_GET_NAME = 'view/getName';
export const STORE_VIEW_GET_TITLE = 'view/getTitle';

// データ設定
export const STORE_DATA_ADD_DATA = 'data/addData';
export const STORE_DATA_DELETE_ALL = 'data/deleteAll';
export const STORE_DATA_DELETE_AT = 'data/deleteAt';
export const STORE_DATA_GETDATA = 'data/getData';

// ローディング設定
export const STORE_VIEW_PROGRESS = 'view/setProgressFlg';
export const STORE_VIEW_IS_PROGRESS = 'view/isProgressFlg';

// ページ制御設定
export const STORE_VIEW_PAGE = 'view/setCurrentPage';
export const STORE_VIEW_GET_PAGE = 'view/getCurrentPage';
export const STORE_VIEW_VIEW_COUNT = 'view/setDisplayCount';
export const STORE_VIEW_GET_VIEW_COUNT = 'view/getDisplayCount';
export const STORE_VIEW_SORT_ORDER = 'view/setSortOrder';
export const STORE_VIEW_GET_SORT_ORDER = 'view/getSortOrder';
export const STORE_VIEW_CLEAR_PAGE = 'view/clearPage';

// モバイル有無
export const STORE_VIEW_MOBILE = 'view/setMobileFlg';
export const STORE_VIEW_IS_MOBILE = 'view/getMobileFlg';

// ブラウザバック
export const STORE_VIEW_BROWSER_BACK = 'view/setBrowserBackFlg';
export const STORE_VIEW_IS_BROWSER_BACK = 'view/getBrowserBackFlg';

// 画面遷移
export const STORE_VIEW_ADD_VIEW_PARAMS = 'view/addViewParams';
export const STORE_VIEW_CLEAR_VIEW_PARAMS = 'view/clearViewParams';
export const STORE_VIEW_DELETE_PARAMS = 'view/deleteParams';
export const STORE_VIEW_GET_PARAMS = 'view/getParams';

// ダイアログ設定
export const STORE_DIALOG_DIALOG_FLG = 'dialog/setDialogFlg';
export const STORE_DIALOG_CALL_BACK = 'dialog/setCallBack';
export const STORE_DIALOG_MESSAGE = 'dialog/setMessage';
export const STORE_DIALOG_BUTTON_LIST = 'dialog/setButtonList';
export const STORE_DIALOG_FOCUS_KEY = 'dialog/setFocusKey';
export const STORE_DIALOG_KIND = 'dialog/setKind';
export const STORE_DIALOG_LINK_FLG = 'dialog/setLinkFlg';
export const STORE_DIALOG_IS_DIALOG_FLG = 'dialog/isDialogFlg';
export const STORE_DIALOG_GET_CALL_BACK = 'dialog/getCallBack';
export const STORE_DIALOG_GET_MESSAGE = 'dialog/getMessage';
export const STORE_DIALOG_GET_BUTTON_LIST = 'dialog/getButtonList';
export const STORE_DIALOG_GET_FOCUS_KEY = 'dialog/getFocusKey';
export const STORE_DIALOG_GET_KIND = 'dialog/getKind';
export const STORE_DIALOG_IS_LINK_FLG = 'dialog/isLinkFlg';

// メッセージ設定
export const STORE_MSG_SET_MSG_INFO = 'message/setMessageInfo';
export const STORE_MSG_GET_MSG = 'message/getMessage';

// 利用者設定
export const STORE_USER_SET_INFO = 'user/setInfo';
export const STORE_USER_SAVE_TOKEN = 'user/saveToken';
export const STORE_USER_GET_TOKEN = 'user/getToken';
export const STORE_USER_GET_INFO = 'user/getInfo';
export const STORE_USER_IS_AUTHENTICATED = 'user/isAuthenticated';
export const STORE_USER_CLEAR = 'user/clear';

// 環境変数設定
export const STORE_ENV_SET_PARAMS = 'env/setEnvParams';
export const STORE_ENV_GET_LIST_MAX_COUNT = 'env/getListMaxCount';
export const STORE_ENV_GET_TOKUBETUKOJO_ROJIN = 'env/getTokubetukojoRojin';
export const STORE_ENV_GET_TOKUBETUKOJO_TOKUTEI = 'env/getTokubetukojoTokutei';
export const STORE_ENV_GET_TOKUBETUKOJO_SYOGAI = 'env/getTokubetukojoSyogai';
export const STORE_ENV_GET_TOKUBETUKOJO_TOKSYOGAI = 'env/getTokubetukojoToksyogai';
export const STORE_ENV_GET_TOKUBETUKOJO_KAFU = 'env/getTokubetukojoKafu';
export const STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA = 'env/getTokubetukojoHitorioya';
export const STORE_ENV_GET_LASTACCESSTIME_UPDATEINTERVAL = 'env/getLastAccessTimeUpdateInterval';

// ajax設定
export const STORE_AJAX_HAS_AJAX_COMPLETED = 'ajax/hasAjaxCompleted';
export const STORE_AJAX_GET_AJAX_COUNT = 'ajax/getAjaxCount';
export const STORE_AJAX_CLEAR_AJAX_COUNT = 'ajax/clearAjaxCount';
export const STORE_AJAX_INCREMENT_AJAX_COUNT = 'ajax/incrementAjaxCount';
export const STORE_AJAX_DECREMENT_AJAX_COUNT = 'ajax/decrementAjaxCount';

